import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Title, Button } from '@qonsoll/react-design'
import { MAX_LENGTH_FIELD, MAX_LENGTH_DESCRIPTION, KEYS } from '__constants__'
import { Form, Input } from 'antd'
import { ImageUploader } from 'components'

const TechnologySimpleForm = (props) => {
  const { initialValues, onSubmit, onCancel, showTitle, form, group } = props

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const [baseForm] = Form.useForm()

  // [COMPUTED_PROPERTIES]
  const usedForm = form || baseForm

  // [HANDLERS]
  const handleCancel = () => {
    usedForm.resetFields()
    onCancel?.()
  }
  const handleKeyPress = (e) => {
    if (e.key === KEYS.ENTER) {
      e.preventDefault()
      e.stopPropagation()
      usedForm?.submit()
    }
  }

  return group ? (
    <>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Technology')}
        </Title>
      )}
      <Form.Item
        label={t('Image url')}
        name={[...group, 'imageUrl']}
        rules={[
          {
            required: false,
            message: t('Please enter your technology image url!')
          }
        ]}>
        <ImageUploader
          placeholder={t('Please enter your technology image url')}
        />
      </Form.Item>
      <Form.Item
        label={t('Name')}
        name={[...group, 'name']}
        rules={[
          {
            required: true,
            message: t('Please enter your technology name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('technology name is too long!') }
        ]}>
        <Input
          placeholder={t('Please enter your technology name')}
          onPressEnter={onSubmit}
        />
      </Form.Item>
      <Form.Item
        label={t('Description')}
        name={[...group, 'description']}
        rules={[
          {
            required: false,
            message: t('Please enter your technology description!')
          },
          {
            max: MAX_LENGTH_DESCRIPTION,
            message: t('technology description is too long!')
          }
        ]}>
        <Input.TextArea
          placeholder={t('Please enter your technology description')}
        />
      </Form.Item>
    </>
  ) : (
    <Form
      form={usedForm}
      initialValues={initialValues}
      onFinish={onSubmit}
      layout="vertical"
      onKeyPress={handleKeyPress}
      autoComplete="off">
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Technology')}
        </Title>
      )}
      <Form.Item
        label={t('Image url')}
        name="imageUrl"
        rules={[
          {
            required: false,
            message: t('Please enter your technology image url!')
          }
        ]}>
        <ImageUploader
          placeholder={t('Please enter your technology image url')}
        />
      </Form.Item>
      <Form.Item
        label={t('Name')}
        name="name"
        rules={[
          {
            required: true,
            message: t('Please enter your technology name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('technology name is too long!') }
        ]}>
        <Input placeholder={t('Please enter your technology name')} />
      </Form.Item>
      <Form.Item
        label={t('Description')}
        name="description"
        rules={[
          {
            required: false,
            message: t('Please enter your technology description!')
          },
          {
            max: MAX_LENGTH_DESCRIPTION,
            message: t('technology description is too long!')
          }
        ]}>
        <Input.TextArea
          placeholder={t('Please enter your technology description')}
        />
      </Form.Item>
      {!form && (
        <>
          <Button mr={2} htmlType="button" onClick={handleCancel}>
            {t('Cancel')}
          </Button>
          <Button type="primary" onClick={() => usedForm.submit()}>
            {t('Save')}
          </Button>
        </>
      )}
    </Form>
  )
}

TechnologySimpleForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  showTitle: PropTypes.bool,
  form: PropTypes.any,
  group: PropTypes.array
}

export default TechnologySimpleForm
